import { FC } from 'react';

import { LmErrorPage, LmErrorPageProps } from '@mes-ui/lemma';
import { Box } from '@mui/material';

import './index.scss';

type ErrorContainerProps = LmErrorPageProps;

export const ErrorContainer: FC<ErrorContainerProps> = (props) => {
  return (
    <Box className="ErrorContainer">
      <LmErrorPage {...props} />
    </Box>
  );
};
